import { put, takeEvery } from "redux-saga/effects";

import { addNotification, loading } from "layouts/AppLayout/modules";
import { getApi } from "../../../sagas";
import { FETCH_APP, FetchAppAction, fetchAppEnd } from "../actions";


// Should be safe to delete
export function* fetchApp(action: FetchAppAction) {

    const { payload } = action;
    const { appId } = payload;

    const api = getApi(payload);

    try {
        yield put(loading(true, action));
        // @ts-ignore yields generate implicit anys as of TS 4.2
        const app = yield api.getApp(appId);
        yield put(fetchAppEnd(undefined, app, action.payload.selectOnSuccess));
    } catch (e) {
        yield put(fetchAppEnd(e));
        yield put(addNotification(e.message, true));
    } finally {
        yield put(loading(false, action));
    }
}

export function* watchFetchApp() {
    yield takeEvery(FETCH_APP, fetchApp);
}
